import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productService from "../Services/productService";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import Loading from "../Components/Loading";
import customerService from "../Services/customerService";
import priceListService from "../Services/priceListService";
import moment from "moment";
import { LoadingDots } from "../Components/LoadingDots";
import quotationService from "../Services/quotationService";
import Dropdown from "../Components/Dropdown";
import DatePicker from "../Components/DatePicker";
import { TbRosetteDiscount } from "react-icons/tb";
import { MdOutlineClear } from "react-icons/md";
import { HiOutlineTrash } from "react-icons/hi";
import { IoReceiptOutline } from "react-icons/io5";
import staffService from "../Services/staffService";

const AddQuotation = () => {
  const [tab, setTab] = React.useState("Part Number");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [discountLoading, setDiscountLoading] = useState(false);
  const [data, setData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [products, setProducts] = useState([]);
  const [file, setFile] = useState(null);
  const [partNumber, setPartNumber] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [priceCheck, setPriceCheck] = useState(false);
  const [deliveryCheck, setDeliveryCheck] = useState(false);
  // const customerProfile = JSON.parse(localStorage.getItem("customer"));
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [selectedReference, setSelectedReference] = useState("");
  const [discountList, setDiscountList] = useState([]);
  const [discount, setDiscount] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [customerDropdown, setCustomerDropdown] = useState(false);
  const [generationLoading, setGenerationLoading] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffOptions, setStaffOptions] = useState([]);
  const dropdownRef = useRef(null);
  const [orderData, setOrderData] = useState({
    customer: "",
    name: "",
    email: "",
    phone: "",
    amount: 0,
  });

  

  const handleCustomerSelect = (customerOrId) => {
    const customer =
      typeof customerOrId === "object"
        ? customerOrId
        : customers.find((c) => parseInt(c.id) === parseInt(customerOrId));

    setSelectedCustomer(customer);
    setCustomerDropdown(false);
  };

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
  const getStaff = async () => {
    try {
      const res = await staffService.fetchAll();

      const formatted = res.staff.map((s) => ({
        label: `${s.name} - ${s.designation}`,
        value: s.id,
        raw: s, // important
      }));
      setStaffOptions(formatted);
    } catch (error) {
      console.error("Failed to fetch staff:", error);
    }
  };

  getStaff();
}, []);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getCustomers = async () => {
      await customerService.fetchAll().then((res) => {
        setCustomers(res.customers);
      });
    };
    getCustomers();
  }, []);

  const normalizeCode = (code) =>
    code?.toString().replace(/-/g, "").trim().toLowerCase();

  useEffect(() => {
    if (products.length !== 0) {
      const getProducts = async () => {
        try {
          setLoading(true);
          setInitialData([]);

          let parts = [];
          let quantities = {};

          // products.forEach((single) => {
          //   if (single["Part Number"] && single.QTY != null) {
          //     const partCode = String(single["Part Number"]).replace(/-/g, "");
          //     parts.push(partCode);
          //     quantities[partCode] = single.QTY;
          //   } else {
          //     console.warn("Skipping invalid row:", single);
          //   }
          // });

          products.forEach((single) => {
            if (single["Part Number"] && single.QTY != null) {
              const partCode = normalizeCode(single["Part Number"]);
              parts.push(partCode);
              quantities[partCode] = single.QTY;
            } else {
              console.warn("Skipping invalid row:", single);
            }
          });

          let response;
          if (discount) {
            response = await productService.searchByVendorCustomerAndDate(
              parts.toString(),
              moment(orderDate).format("YYYY-MM-DD"),
              selectedCustomer.id,
              selectedReference,
            );
          } else {
            response = await productService.searchByPart(parts.toString());
          }

          // const combinedProducts = response.products.map((item) => {
          //   const requestedQty = quantities[item.vendor_code] || 0;
          //   const availableQty = item.quantity;

          //   return {
          //     ...item,
          //     qty: requestedQty > availableQty ? availableQty : requestedQty,
          //     limited: requestedQty > availableQty,
          //     empty: availableQty === 0,
          //     show: true,
          //   };
          // });

          const combinedProducts = response.products.map((item) => {
            const partCode = normalizeCode(item.vendor_code);
            const requestedQty = quantities[partCode] || 0;
            const availableQty = item.quantity;

            return {
              ...item,
              qty: requestedQty > availableQty ? availableQty : requestedQty,
              limited: requestedQty > availableQty,
              empty: availableQty === 0,
              show: true,
            };
          });

          setInitialData((prev) => [...prev, ...combinedProducts]);

          const quotationPayload = {
            customer_id: selectedCustomer.id,
            order_date: moment(orderDate).format("YYYY-MM-DD"),
            products: combinedProducts,
          };

          setLoading(false);
          setProducts([]);
        } catch (e) {
          console.error("Error in quotation process:", e);
          setLoading(false);
        }
      };

      getProducts();
    }
  }, [products]);

  useEffect(() => {
    const checkDiscountForCustomer = async () => {
      setDiscountLoading(true);
      try {
        const response = await priceListService.priceListByCustomer(
          selectedCustomer.id,
        );
        setDiscountList(response.priceList);
        setOrderDate(response.priceList[0]?.date);
        setSelectedReference(response.priceList[0]?.reference_no);
        setDiscountLoading(false);
      } catch (e) {
        console.error("Failed to fetch List", e);
      }
    };
    checkDiscountForCustomer();
  }, [selectedCustomer]);

  useEffect(() => {
    setData(
      initialData.reduce((acc, current) => {
        const isDuplicate = acc.some(
          (item) =>
            item.id === current.id && item.supplier === current.supplier,
        );
        if (!isDuplicate) {
          acc.push(current);
        }
        return acc;
      }, []),
    );
  }, [initialData]);

  useEffect(() => {
    if (data.length !== 0) {
      setShowTable(true);
    }
  }, [data]);

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        setFile(data);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = () => {
    if (file) {
      const workbook = xlsx.read(file, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsx.utils.sheet_to_json(worksheet);
      setProducts(json);
    } else {
      toast.error("Please upload any file!");
    }
  };

  const handleChange = (v) => {
    setTab(v);
  };

  const handleInput = (value, tab) => {
    if (tab === "Part Number") {
      setPartNumber(value);
    }
  };

  const handleSearch = (tab) => {
    if (tab === "Part Number") {
      if (partNumber) {
        setProducts((p) => [...p, { "Part Number": partNumber, QTY: 1 }]);
      }
    }
  };

  const totalQuantity = data.reduce(
    (acc, item) => (item.show ? acc + item.qty : acc),
    0,
  );
  const totalWeight = data.reduce(
    (acc, item) => (item.show ? acc + parseFloat(item.weight || 0) : acc),
    0,
  );
  const totalPrice = data.reduce(
    (acc, item) =>
      item.show ? acc + item.qty * parseFloat(item.price).toFixed(2) : acc,
    0,
  );

  const totalWithVAT = data
    .reduce((acc, item) => {
      if (!item.show) return acc;

      const price = parseFloat(item.price);
      const quantity = item.qty;
      const vat = item.vat_percentage;

      const itemTotal = price * quantity + price * quantity * (vat / 100);

      return acc + itemTotal;
    }, 0)
    .toFixed(2);

  const proceedToCheckout = () => {
    setGenerationLoading(true);
    let submit = { ...orderData };
    const selectedStaffObj = staffOptions.find(
      (s) => s.value === selectedStaff
    );
    const transformedProducts = data.map((item) => ({
      brand: item.brand,
      created_at: item.created_at,
      delivery: item.delivery,
      product: item.id,
      price: item.price,
      quantity: item.qty,
      show: item.show,
      supplier_code: item.supplier_code,
      supplier: item.supplier,
      title: item.title,
      vat_percentage: item.vat_percentage,
      vendor_code: item.vendor_code,
      weight: item.weight,
    }));

    //const selectedDiscount = discountList.find((d) => d.date === orderDate);
    const selectedDiscount = discountList.find(
      (d) =>
        moment(d.date).format("YYYY-MM-DD") ===
          moment(orderDate).format("YYYY-MM-DD") &&
        d.reference_no === selectedReference,
    );

    submit.amount = totalPrice;
    submit.vat_amount = totalWithVAT;
    submit.quotation_date = date;
    submit.email = selectedCustomer?.email;
    submit.phone = selectedCustomer?.phone_number;
    submit.customer = selectedCustomer?.id;
    submit.staff = selectedStaffObj?.raw?.name || "";
    submit.recipient =
      selectedCustomer?.first_name + selectedCustomer?.last_name;
    submit.products = transformedProducts.filter((value) => value.show);
    if (selectedDiscount) {
      submit.reference_no = selectedDiscount.reference_no;
    }
    quotationService.submitQuotation(submit).then((response) => {
      if (response.responseCode === 200) {
        setGenerationLoading(false);
        navigate("/quotation");
      }
    });
  };

  const handleIncrement = (v, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && item.quantity >= v && v > 0
          ? { ...item, qty: v }
          : item,
      ),
    );
  };

  const handleDecrement = (v, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && item.quantity >= v && v > 0
          ? { ...item, qty: v }
          : item,
      ),
    );
  };

  const initialDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  const downloadQuotation = () => {
    const summary = [
      { Weight: "Total Quantity", Delivery: totalQuantity },
      { Weight: "Total Weight", Delivery: totalWeight },
      { Weight: "Total Price", Delivery: totalPrice.toFixed(2) },
    ];

    const transformedData = data.map((item) => ({
      "Vendor Code": item.vendor_code,
      Brand: item.brand,
      Title: item.title,
      "Ordered Quantity": item.qty,
      Price: item.price,
      Weight: item.weight,
      Delivery: item.delivery,
    }));

    const blankRows = [{}, {}, {}];
    const fullData = [...transformedData, ...blankRows, ...summary];
    const worksheet = xlsx.utils.json_to_sheet(fullData);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Quotation");

    const excelBuffer = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "quotation.xlsx");
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
  };

  const handleCheckBoxChange = (v, n) => {
    if (n === "min-price") {
      setPriceCheck(v);
      setDeliveryCheck(false);
      if (v) {
        const vendors = {};
        data.map((item) => {
          const { vendor_code, price } = item;
          if (vendors[vendor_code]) {
            if (price < vendors[vendor_code].price) {
              vendors[vendor_code].show = false;
              item.show = true;
            } else {
              item.show = false;
            }
          } else {
            vendors[vendor_code] = item;
            item.show = true;
          }
        });
      } else {
        setData(
          data.map((product) => ({
            ...product,
            show: true,
          })),
        );
      }
    } else if (n === "delivery-days") {
      setPriceCheck(false);
      setDeliveryCheck(v);
      if (v) {
        const vendors = {};
        data.map((item) => {
          const { vendor_code, delivery } = item;
          if (vendors[vendor_code]) {
            if (delivery < vendors[vendor_code].delivery) {
              vendors[vendor_code].show = false;
              item.show = true;
            } else {
              item.show = false;
            }
          } else {
            vendors[vendor_code] = item;
            item.show = true;
          }
        });
      } else {
        setData(
          data.map((product) => ({
            ...product,
            show: true,
          })),
        );
      }
    }
  };

  const handleSelect = (selectedOption) => {
    setOrderDate(selectedOption.date);
    setSelectedReference(selectedOption.reference_no);
    setIsOpen(false);
  };

  const selected = discountList.find(
    (item) =>
      item.date === orderDate && item.reference_no === selectedReference,
  );

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      {/* Head */}
      <h1 className="font-bold text-center text-3xl text-secondary mt-10">
        Add Quotation
      </h1>

      <div className="px-80">
        <div className="mt-10 flex flex-col items-center">
          <div className="grid grid-cols-3 gap-4">
            <DatePicker
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <Dropdown
              styling="col-span-2"
              selected={selectedCustomer?.id}
              placeholder="Select Customer"
              onChange={handleCustomerSelect}
              options={customers.map((c) => ({
                label: `${c.first_name} ${c.last_name} - ${c.email}`,
                value: c.id,
              }))}
            />

            <Dropdown
              styling="col-span-2"
              selected={selectedStaff}
              placeholder="Select Staff"
              onChange={(value) => {
                const selected = staffOptions.find((s) => s.value === value);
                setSelectedStaff(value);        // for dropdown
              }}
              options={staffOptions}
            />
            {orderDate !== null && !discountLoading && (
              <div className="w-[350px]">
                {discountList?.length > 0 && (
                  <div className="relative" ref={dropdownRef}>
                    <button
                      onClick={() => setIsOpen(!isOpen)}
                      className="w-full bg-[#f9fafb] text-left pl-4 py-[9px] text-sm font-medium rounded-[0.5rem] border hover:shadow-md hover:bg-white hover:border-gray-500 duration-300 focus:outline-primary"
                    >
                      {selected ? (
                        <div className="flex flex-row justify-between pr-2">
                          <span>
                            {moment(selected.date).format("DD-MM-YYYY")} -
                            <span className="font-bold text-xs text-blue-600 ml-1" />
                            {selected.reference_no}
                          </span>
                          <svg
                            className={`fill-current h-4 w-4 ml-2 transition-transform duration-300 ${
                              isOpen ? "rotate-180" : ""
                            }`}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                          </svg>
                        </div>
                      ) : (
                        <p className="text-xs font-light text-gray-400">
                          Select Order Date
                        </p>
                      )}
                    </button>

                    {isOpen && (
                      <div className="absolute z-10 w-full bg-white border border-gray-300 mt-2 rounded-[9px] max-h-60 overflow-y-auto shadow-lg">
                        {discountList.map((discount) => (
                          <div
                            key={discount.id}
                            onClick={() => handleSelect(discount)}
                            className="cursor-pointer px-4 py-2 hover:bg-gray-100 text-sm"
                          >
                            <h6>
                              {moment(discount.date).format("DD-MM-YYYY")} -
                              <span className="font-bold text-xs text-blue-600 ml-1">
                                REFERENCE NO.{" "}
                              </span>
                              {discount.reference_no}
                            </h6>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* {orderDate !== null && !discountLoading && (
              <div className="max-w-[350px]">
                {discountList?.length > 0 && (
                  <Dropdown
                    selected={
                      <span>
                        {moment(selected.date).format("DD-MM-YYYY")} -
                        <span className="font-bold text-xs text-blue-600 ml-1" />
                        {selected.reference_no}
                      </span>
                    }
                    placeholder="Select Order Date"
                    options={discountList.map((d) => ({
                      label: `${moment(d.date).format("DD-MM-YYYY")} - ${d.reference_no}`,
                      value: d.id,
                      raw: d,
                    }))}
                    onChange={(value) => {
                      // We use == to avoid string/number type errors
                      const discount = discountList.find((d) => d.id == value);
                      if (discount) {
                        handleSelect(discount);
                      }
                      console.log(value);
                    }}
                    renderLabel={(option) => (
                      <span>
                        {moment(option.raw.date).format("DD-MM-YYYY")} -
                        <span className="font-bold text-xs text-blue-600 ml-1">
                          {" "}
                          REFERENCE NO.{" "}
                        </span>
                        {option.raw.reference_no}
                      </span>
                    )}
                  />
                )}
              </div>
            )} */}
          </div>
          {/* Buttons */}
          {orderDate && !discountLoading && (
            <div className="mt-10 flex justify-center">
              {discount ? (
                <button
                  onClick={() => setDiscount(false)}
                  className={`bg-white text-red-600 border font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
                >
                  <MdOutlineClear className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                  Clear Changes
                </button>
              ) : (
                <button
                  onClick={() => setDiscount(true)}
                  className={`bg-cyan-600 text-white border font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
                >
                  <TbRosetteDiscount className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                  Apply Special Discount
                </button>
              )}
            </div>
          )}
          {/* Discount Message */}
          {/* {!discountLoading && (
            <div className="flex justify-center w-full mt-6 font-bold">
              {discount ? (
                <p className="mt-2 text-green-500 text-center bg-green-500 bg-opacity-20 px-4 py-1 rounded-full">
                  Discount Applied
                </p>
              ) : (
                <p className="mt-2 text-red-500 text-center bg-red-500 bg-opacity-20 px-4 py-1 rounded-full">
                  No Discount
                </p>
              )}
            </div>
          )} */}
          {/* Loader (if any) */}
          {discountLoading && <LoadingDots />}
        </div>

        {selectedCustomer && discount ? (
          <div className=" flex justify-center mt-10 w-full">
            <div className="flex flex-row w-[80%] justify-end py-2 rounded-3xl">
              <input
                onChange={(e) => handleFileSelect(e)}
                type="file"
                className="primary-input !rounded-r-none
                                file:mr-4 file:py-[2px] file:px-3 file:rounded-md file:duration-300
                                file:border-0 file:text-sm file:font-medium
                              file:bg-white file:text-black
                              hover:file:bg-primary hover:file:text-white"
              />
              <button
                onClick={() => ProceedFileRead()}
                className="bg-primary px-4 w-40 py-1 rounded-r-[0.5rem] text-white font-medium text-sm"
              >
                Proceed
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <Loading />
        </div>
      ) : (
        <>
          {showTable && (
            <div className="flex flex-col w-full gap-2 mt-5">
              <div className="w-fit border rounded-md px-4 py-2 shadow-md text-sm font-semibold text-cyan-600">
                {/* <div className="mt-5 md:rounded-xl flex flex-row gap-3">
                  <label className="font-semibold">
                    <input
                      checked={priceCheck}
                      type="checkbox"
                      name="min-price"
                      id="min-price"
                      onChange={(e) =>
                        handleCheckBoxChange(e.target.checked, e.target.name)
                      }
                    />{" "}
                    Display goods with a minimum price
                  </label>
                  <br />
                  <label className="font-semibold">
                    <input
                      checked={deliveryCheck}
                      type="checkbox"
                      name="delivery-days"
                      id="delivery-days"
                      onChange={(e) =>
                        handleCheckBoxChange(e.target.checked, e.target.name)
                      }
                    />{" "}
                    Display goods with minimum delivery days
                  </label>
                </div> */}
                <p>{data.length} Products Found</p>
              </div>
              <div className="table-div">
                <table className="w-full">
                  <thead>
                    <tr className="border-y-2 text-left w-full text-black text-[10px]">
                      <th className=" py-2 text-center w-[8%]">Qty</th>
                      <th className="py-6 w-[8%]">Brand</th>
                      <th className="py-2 w-[8%]">Part No.</th>
                      <th className="py-2  w-[14%]">Title</th>
                      <th className=" py-2 w-[8%]">Stock</th>
                      <th className=" py-2 w-[8%]">Weight (Kg)</th>
                      <th className=" py-2 w-[8%]">Total Weight</th>
                      <th className="py-2 w-[8%]">Delivery</th>
                      <th className="py-2 w-[8%]">Price</th>
                      <th className="py-2 w-[6%]">Total Price</th>
                      <th className="py-2 w-[4%]">VAT</th>
                      <th className="py-2 w-[8%]">Total Price Incl VAT</th>
                      <th className="py-2 text-left w-[8%]">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((data, index) => (
                      <tr
                        key={index}
                        className={`border-b border-gray-200  ${
                          data.show ? "" : "hidden"
                        }`}
                      >
                        <td className="py-4 text-center text-[12px] w-[8%]">
                          <div className="flex rounded-md justify-center items-center ">
                            <div className="flex flex-row items-center gap-1">
                              <div>
                                <FaMinus
                                  className="cursor-pointer p-1 h-5 w-5 bg-red-500 rounded-md text-white"
                                  onClick={() =>
                                    handleDecrement(data.qty - 1, data.id)
                                  }
                                />
                              </div>
                              <p
                                className={`w-[20px] text-center font-extrabold rounded-md`}
                              >
                                {data.qty}
                              </p>
                              <div>
                                <FaPlus
                                  className="cursor-pointer p-1 h-5 w-5 bg-green-500 rounded-md text-white"
                                  onClick={() =>
                                    handleIncrement(data.qty + 1, data.id)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className=" py-4 text-left font-bold text-[12px] w-[8%]">
                          {data.brand}
                        </td>
                        <td className=" py-4  text-left text-[12px] w-[8%]">
                          {data.vendor_code}
                        </td>

                        <td className="py-4 text-left text-[12px] w-[14%]">
                          {data.title}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          <div className="flex flex-row items-center gap-2">
                            <p>{data.quantity}</p>
                            <div
                              className={`px-[7px] py-[1px] rounded-full bg-opacity-20 font-bold ${
                                data.empty
                                  ? "bg-red-500 text-red-500"
                                  : data.limited
                                    ? "bg-amber-500 text-amber-500"
                                    : "hidden"
                              }`}
                            >
                              !
                            </div>
                          </div>
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          {data.weight}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          {parseFloat(data.quantity * data.weight).toFixed(2)}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          {data.delivery}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          <input
                            className={`w-16 text-center border-gray-500 py-2 bg-gray-100 rounded-lg`}
                            value={parseFloat(data.price).toFixed(2)}
                          />
                        </td>
                        <td className="py-4 text-left font-bold text-[12px] w-[8%] ">
                          {parseFloat(
                            parseFloat(data.price).toFixed(2) * data.qty,
                          ).toFixed(2)}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[6%]">
                          {(
                            parseFloat(data.price).toFixed(2) *
                            data.qty *
                            (data.vat_percentage / 100)
                          ).toFixed(2)}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          {(
                            parseFloat(data.price) * data.qty +
                            parseFloat(data.price) *
                              data.qty *
                              (data.vat_percentage / 100)
                          ).toFixed(2)}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          <div className="flex flex-row gap-4">
                            <div onClick={() => initialDelete(data.id)}>
                              <HiOutlineTrash className="h-4 w-4 text-red-500" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className=" flex flex-col md:flex-row self-end justify-between w-[100%] p-5 mt-4 rounded-xl bg-white">
                <div className={`flex flex-row`}>
                  <div className=" flex flex-row md:items-center gap-3 justify-center bg-white border shadow-md py-8 rounded-2xl px-10">
                    <div className="w-[120px] flex flex-col text-xl font-bold items-center">
                      <span className="text-gray-700 text-sm font-medium text-center">
                        Total Price
                      </span>
                      <div className="flex justify-center mt-1">
                        <h1 className="flex justify-center text-center font-extrabold text-gray-700 text-2xl">
                          {parseFloat(totalPrice).toFixed(2)}
                        </h1>
                        <h1 className="ml-1 font-light text-gray-500 text-[10px]">
                          AED
                        </h1>
                      </div>
                    </div>
                    <div className={`h-[60px] bg-gray-400 w-[1px]`} />
                    <div className="w-[120px] flex flex-col text-xl font-bold items-center">
                      <span className="text-gray-700 text-sm font-medium text-center">
                        Total Incl VAT
                      </span>
                      <div className="flex justify-center mt-1">
                        <h1 className="flex justify-center text-center font-extrabold text-gray-700 text-2xl">
                          {parseFloat(totalWithVAT).toFixed(2)}
                        </h1>
                        <h1 className="ml-1 font-light text-gray-500 text-[10px]">
                          AED
                        </h1>
                      </div>
                    </div>
                    <div className={`h-[60px] bg-gray-400 w-[1px]`} />
                    <div className="w-[120px] flex flex-col text-xl font-bold items-center">
                      <span className="text-gray-700 text-sm font-medium text-center">
                        Total Weight
                      </span>
                      <div className="flex justify-center mt-1">
                        <h1 className="flex justify-center text-center font-extrabold text-gray-700 text-2xl">
                          {parseFloat(totalWeight).toFixed(2)}
                        </h1>
                        <h1 className="ml-1 font-light text-gray-500 text-[10px]">
                          KG
                        </h1>
                      </div>
                    </div>
                    <div className={`h-[60px] bg-gray-400 w-[1px]`} />
                    <div className="w-[120px] flex flex-col text-xl font-bold items-center">
                      <span className="text-gray-700 text-sm font-medium text-center">
                        Total Quantity
                      </span>
                      <div className="flex justify-center mt-1">
                        <h1 className="flex justify-center text-center font-extrabold text-gray-700 text-2xl">
                          {parseFloat(totalQuantity).toFixed(0)}
                        </h1>
                        <h1 className="ml-1 font-light text-gray-500 text-[10px]">
                          PCS
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-end justify-end gap-3 w-[100%] md:w-[50%]">
                  <div>
                    {" "}
                    <button
                      onClick={() => proceedToCheckout()}
                      className="flex flex-row items-center justify-center gap-4"
                    >
                      {generationLoading ? (
                        <div className="bg-primary text-white border font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group gap-4">
                          <LoadingDots />
                          <p>Processing</p>
                        </div>
                      ) : (
                        <button
                          className={`bg-primary text-white border font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
                        >
                          <IoReceiptOutline className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                          Generate Quotation
                        </button>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}{" "}
        </>
      )}
    </main>
  );
};

export default AddQuotation;
